import { useQuery, skipToken, keepPreviousData } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { DashboardTransactionsSuccessSummaryParams } from 'config/requests/dashboard';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TransactionsSuccessSummary } from 'types/embedded/dashboard';
import { ErrorData } from 'types/embedded/error';

import { useDashboardApi } from './useDashboardApi';

export function useGetDashboardTransactionsSuccessSummary(
  params: DashboardTransactionsSuccessSummaryParams | null,
) {
  const translate = useTypedTranslate();
  const { api, aggregatedQueryKey } = useDashboardApi();

  const {
    data: summary,
    isFetching,
    isLoading,
    error,
  } = useQuery<TransactionsSuccessSummary, AxiosError<ErrorData>>({
    queryKey: ['dashboard/transaction_success_summary', aggregatedQueryKey, params],
    queryFn: params ? () => api.getTransactionsSuccessSummary(params) : skipToken,
    placeholderData: keepPreviousData,
  });

  const errorMessage = error
    ? error.response?.data?.errors?.[0].title || translate('app.common.serverError')
    : undefined;

  return { summary, isFetching, isLoading, error: errorMessage };
}

export type GetDashboardTransactionsSuccessSummaryResult = ReturnType<
  typeof useGetDashboardTransactionsSuccessSummary
>;
